import fitvids from "fitvids";
import helpers from "../utils/helpers";
import LazyLoad from "vanilla-lazyload";

const Common = {
  init() {
    new LazyLoad();

    Common.events();
    Common.video();
  },

  video() {
    $(".btn-play").on("click", (e) => {
      const btn = $(e.currentTarget);

      btn.closest(".video-container").find(".video-overlay").fadeOut();
      btn.closest(".video-container").find("video")[0].play();
    });

    $(".mp-video__poster").on("click", (e) => {
      const btn = $(e.currentTarget);
      const wrapperEl = btn.closest(".mp-video");

      wrapperEl.addClass("playing");
      wrapperEl.find("video")[0].play();
    });

    $(window).on("scroll", function () {
      $(".mp-video.autoplay").each(function () {
        const wraperEl = $(this);
        const videoEl = wraperEl.find("video");

        // Check if video is in viewport
        if (helpers.isInViewport(videoEl[0])) {
          // Play video
          videoEl[0].play();
          wraperEl.addClass("playing");
        }
      });
    });
  },

  events() {
    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );

    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Fitvids
    fitvids();

    // Video.
    $(".flex-video__overlay").on("click", function () {
      $(this).parent().addClass("playing").find("video")[0].play();
    });
  },
};

export default Common;
